import {i18nConfigModel} from '@wallaby-ui/core';
import {isEmpty} from 'lodash';
import * as Plotly from 'plotly.js';
import defaultLocale from 'plotly.js/src/locale-en';
import {useEffect} from 'react';

const MISSING_PLOTLY_LOCALE_DEFINITIONS = {
  cs: {format: {decimal: ',', thousands: ' '}},
  sk: {format: {decimal: ',', thousands: ' '}},
};

const loadLocaleData = (i18nConfig: i18nConfigModel.I18nConfigRaw) => {
  const i18nConfigModelInstance = new i18nConfigModel.I18nConfig(i18nConfig);
  i18nConfigModelInstance.getUsedApplicationLanguages()?.forEach((language) => {
    let localeData = defaultLocale;
    // load locale data for all supported languages
    try {
      if (language.getLocale()) {
        // get definition from plotly library
        localeData = require(`plotly.js/lib/locales/${language.getLocale()}.js`);
      }
    } catch (ex) {
      // fallback locale
      localeData = defaultLocale;
    }
    if (language.getLocale()) {
      const additionalDefinition =
        MISSING_PLOTLY_LOCALE_DEFINITIONS[language.getLocale()];
      if (additionalDefinition) {
        // add additional definition
        localeData = {
          ...localeData,
          format: {...localeData.format, ...additionalDefinition.format},
        };
      }
    }
    Plotly.register(localeData);
  });
};

export function usePlotlyLocaleInit(
  i18nConfig: i18nConfigModel.I18nConfigRaw,
  currentLocale: string
) {
  useEffect(() => {
    if (!isEmpty(i18nConfig)) {
      loadLocaleData(i18nConfig);
    }
    Plotly.setPlotConfig({locale: currentLocale});
  }, [currentLocale, i18nConfig]);
}
